import { useEffect, useState } from "react"

import { App, Flex, Modal, Spin, Typography } from "antd"
import { t } from "i18next"
import { useDispatch, useSelector } from "react-redux"

import Icon from "../../../../../Icon"
import ReferralActions from "../../../reducer"
import PaymentMethodForm from "./PaymentMethodForm"

import "./PaymentMethodFormModal.less"

const { Text } = Typography

const PaymentMethodFormModal = ({ open, close, type }) => {
  const dispatch = useDispatch()
  const { notification } = App.useApp()
  const [isValidForm, setIsValidForm] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { outsiderPayoutMethod, outsiderPayoutMethodFetching } = useSelector(
    (state) => state.referrals
  )
  const isMobile = useSelector((state) => state.nav.isMobile)

  useEffect(() => {
    if (open) {
      dispatch(ReferralActions.getOutsiderPayoutMethodRequest())
    }
  }, [open])

  const onSubmit = (values) => {
    setIsSubmitting(true)

    const payload = {
      data: values,
      onSuccess: () => {
        close()
        setIsSubmitting(false)
      },
      onError: (data) => {
        setIsSubmitting(false)
        notification.error({
          message: data?.message?.detail || "An error occurred while saving the payment method.",
          closeIcon: <Text>{t("Dismiss")}</Text>
        })
      }
    }

    if (type === "add") {
      dispatch(ReferralActions.addOutsiderPayoutMethodRequest(payload))
    } else if (type === "edit") {
      dispatch(ReferralActions.updateOutsiderPayoutMethodRequest(payload))
    }
  }

  return (
    <Modal
      open={open}
      onClose={close}
      onCancel={close}
      onOk={close}
      title={
        <Flex vertical gap={8}>
          <Text className="title">Payment details</Text>
          <Text type="secondary" strong>
            View and manage your payment methods for withdrawals
          </Text>
        </Flex>
      }
      closeIcon={<Icon type="cross_small" />}
      cancelText="Cancel"
      okText="Save"
      okButtonProps={{
        size: "large",
        form: "payment-method-form",
        htmlType: "submit",
        disabled: !isValidForm,
        loading: isSubmitting,
        onClick: (e) => e.stopPropagation()
      }}
      cancelButtonProps={{
        size: "large"
      }}
      rootClassName="payment-method-form-modal clear-bg"
      classNames={{
        content: "clear-bg"
      }}
      width={isMobile ? "100%" : 442}
      centered={!isMobile}
      wrapClassName={isMobile ? "payment-method-form-modal--mobile" : ""}
      getContainer={isMobile ? document.body : () => document.getElementById("global-wrap")}
      destroyOnClose
    >
      {outsiderPayoutMethodFetching ? (
        <Flex align="center" justify="center">
          <Spin />
        </Flex>
      ) : (
        <PaymentMethodForm
          initialValues={outsiderPayoutMethod}
          onSubmit={onSubmit}
          setIsValidForm={setIsValidForm}
        />
      )}
    </Modal>
  )
}

export default PaymentMethodFormModal
